/* ═══════════════════════════════════════════════════════════════════════
   CRÉAPANEL — assets/cp-forme.js (chargé par snippets/cp-head-extras.liquid,
   fiches produit) — CHANGEMENT DE FORME SANS PERDRE SES COTES
   Le moteur remet toutes les cotes aux valeurs par défaut à chaque changement
   de forme (configurator-main.js, resetDimensionsForLayout, l. 1885) : un client
   qui a saisi L1 = 3000 et P1 = 650 en droit retrouve 2400 × 600 en passant au L,
   sans le savoir.
   Ici : la longueur principale (L1) et la profondeur principale (P1) affichées
   avant le changement sont reportées sur la nouvelle forme, par le MÊME onCommit
   que la fenêtre de cote du moteur (relevé au moment où il crée ses cotes).
   Bornes : celles de la règle active (_eff.lengthLimits ; profondeurs permises
   quand la règle de profondeur est active). Une valeur qui doit changer est
   annoncée : « L1 ramenée à … mm pour cette forme ».
   Le décor et l'épaisseur ne sont pas touchés par le moteur. Moteur non modifié.
    changer seulement le sens de la forme garde l'angle entre les murs.
    le report ne ferme jamais un G (passage gardé, sinon 800 mm, retour raccourci et
   annoncé) ; message quand une saisie rend le passage étroit (< 800 mm) ou ferme le G.
   ═══════════════════════════════════════════════════════════════════════*/
(function () {
  'use strict';

  function getApp() { try { return (typeof App !== 'undefined') ? App : window.App; } catch (e) { return window.App; } }
  function num(v) { var n = Number(v); return isFinite(n) ? n : NaN; }
  function toast(msg) { if (window.CFG_UI && window.CFG_UI.toast) window.CFG_UI.toast(msg, 'info', 7000); }

  /*  choix du client sur une case de chant libre (état qu'elle aura après le clic du moteur)*/
  document.addEventListener('click', function (e) {
    var v = e.target && e.target.closest && e.target.closest('.edge-checkbox-visual[data-edge]'), A = getApp();
    if (!v || !A || !A.S || v.dataset.disabled === '1' || v.classList.contains('disabled')) return;
    A.S.cpClientBanding = A.S.cpClientBanding || {};
    A.S.cpClientBanding[v.dataset.edge] = !v.classList.contains('checked');
  }, true);

  /* cotes de saisie affichées : « L1 : 2400 » -> { L1: 2400 } (libellés du moteur, et L1…P4 du G via cp-a11y) */
  function shown(A) {
    var out = {};
    if (!A.dims) return out;
    Array.prototype.forEach.call(A.dims.querySelectorAll('.dim:not(.readonly) .label span'), function (sp) {
      var m = sp.textContent.trim().match(/^([LPH]\d)\s*:\s*(\d+)/i);   /* A-364 : « H1 » = P1 d'une crédence */
      if (m) out[m[1].toUpperCase().replace(/^H/, 'P')] = num(m[2]);
    });
    return out;
  }

  /* profondeurs permises quand la règle de profondeur est active (même filtre que showDepthSelector) :
     valeurs standard + plages sur mesure (min_mm…max_mm) */
  function allowedDepths(A) {
    var rule = A._eff && A._eff.depthRule;
    if (!(rule && rule.enabled)) return null;
    var cfg = window.CONFIGURATOR_CONFIG || {}, std = cfg.depthStandards || [], cus = cfg.depthCustomRanges || [];
    if (Array.isArray(rule.allowed) && rule.allowed.length) {
      var ok = {}; rule.allowed.forEach(function (id) { ok[id] = true; });
      std = std.filter(function (d) { return ok[d.id]; });
      cus = cus.filter(function (d) { return ok[d.id]; });
    }
    var vals = std.map(function (d) { return num(d.depth_mm); }).filter(function (v) { return v > 0; });
    var ranges = cus.map(function (d) { return [num(d.min_mm) || 0, num(d.max_mm) || 99999]; });
    return (vals.length || ranges.length) ? { vals: vals, ranges: ranges } : null;
  }
  function bound(A, key, v) {
    if (key[0] === 'P') {
      var ok = allowedDepths(A);
      if (ok) {
        if (ok.vals.indexOf(v) >= 0 || ok.ranges.some(function (r) { return v >= r[0] && v <= r[1]; })) return v;
        var cand = ok.vals.slice();                                        /* sinon : profondeur permise la plus proche */
        ok.ranges.forEach(function (r) { cand.push(r[0], r[1]); });
        return cand.reduce(function (b, x) { return Math.abs(x - v) < Math.abs(b - v) ? x : b; }, cand[0]);
      }
      var dl = (A._eff && A._eff.depthLimits) || {};
      return Math.min(num(dl.max) || 2000, Math.max(num(dl.min) || 300, v));
    }
    var ll = (A._eff && A._eff.lengthLimits) || {};
    return Math.min(num(ll.max) || 10000, Math.max(num(ll.min) || 10, v));
  }

  /* ── : un G n'est jamais fermé par le report ──
     Passage = distance entre le bout du retour et le montant d'en face (les deux sens) : à 90°,
     largeur hors-tout − les deux montants − le retour ; avec les angles par coin, sur la géométrie réelle.*/
  var PASSAGE_MIN = 800, RETOUR_MIN = 300;
  function gWidth(S) { return num(S.gDir === 'left' ? S.Pgright : S.Pgleft) + num(S.Gtop); }
  function gOpening(S) {
    /* angles par coin du G : passage mesuré sur la géométrie réelle (bout du retour -> bord intérieur du montant d'en face) */
    if (typeof window.CP_geomG === 'function' && typeof window.CP_gParams === 'function') {
      try { var o = window.CP_geomG(window.CP_gParams(S)).opening; if (isFinite(o)) return o; } catch (e) {}
    }
    return gWidth(S) - num(S.Pgleft) - num(S.Pgright) - num(S.Greturn);
  }
  /* après le report dans un G : on garde le passage d'avant (sinon 800 mm) en raccourcissant le retour */
  function keepGOpen(A, before, notes) {
    var S = A.S, op = gOpening(S);
    if (op >= before) return;
    var base = gWidth(S) - num(S.Pgleft) - num(S.Pgright);
    var target = (base - before >= RETOUR_MIN) ? before : ((base - PASSAGE_MIN >= RETOUR_MIN) ? PASSAGE_MIN : null);
    if (target === null) { if (op <= 0) notes.push('le plan du haut est trop court pour ce G : raccourcissez le retour ou allongez L1'); return; }
    var ret = Math.round(base - target);
    if (ret >= num(S.Greturn)) return;
    S.Greturn = ret; A.render();
    notes.push('retour ramené à ' + mmTxt(ret) + ' mm pour garder un passage de ' + mmTxt(target) + ' mm');
  }
  /* lot « messages 2 », T7 : les nombres des messages avec l'espace des milliers (« 3 579 mm ») */
  function mmTxt(v) { return String(Math.round(num(v))).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
  var lastG = null, lastU = null;                                          /* message une fois par changement d'état */
  function warnG(A) {
    var S = A.S;
    if (S.layout !== 'g-shape') lastG = null;
    else {
      var op = Math.round(gOpening(S)), st = op <= 0 ? 'ferme' : (op < PASSAGE_MIN ? 'etroit' : 'ok');
      if (st !== lastG && st !== 'ok') toast(st === 'ferme'
        ? 'Le retour touche le montant d\'en face : ce G est fermé et ne peut pas être commandé. Raccourcissez le retour ou allongez le plan du haut.'
        : 'Passage étroit : ' + mmTxt(op) + ' mm entre le retour et le montant d\'en face (800 mm conseillés).');
      lastG = st;
    }
    lignePassage(A);
    /* U court : message non bloquant sous 800 mm entre les jambes*/
    if (S.layout !== 'u-shape') { lastU = null; return; }
    var gap = Math.round(uGap(S)), su = gap < PASSAGE_MIN ? 'etroit:' + gap : 'ok';
    if (su !== lastU && su !== 'ok') toast('Passage étroit : ' + mmTxt(gap) + ' mm entre les jambes du U (800 mm conseillés).');
    lastU = su;
  }
  /* passage étroit (U, G) : en plus du message (qui s'efface après quelques secondes), une ligne sous le dessin, tant que
     le passage reste sous 800 mm. Non bloquant : le client commande ce qu'il veut. */
  function lignePassage(A) {
    var S = A.S, t = '';
    if (S.layout === 'u-shape') { var gap = Math.round(uGap(S)); if (gap < PASSAGE_MIN) t = 'Passage étroit : ' + mmTxt(gap) + ' mm entre les jambes du U (800 mm conseillés).'; }
    else if (S.layout === 'g-shape') {
      var op = Math.round(gOpening(S));
      if (op <= 0) t = 'Le retour touche le montant d\'en face : ce G est fermé et ne peut pas être commandé. Raccourcissez le retour ou allongez le plan du haut.';
      else if (op < PASSAGE_MIN) t = 'Passage étroit : ' + mmTxt(op) + ' mm entre le retour et le montant d\'en face (800 mm conseillés).';
    }
    var el = document.getElementById('cp-passage');
    if (!t) { if (el && el.parentNode) el.parentNode.removeChild(el); return; }
    var st = document.getElementById('stage'), host = document.getElementById('cp-stage-extras') || (st && st.parentNode); if (!host) return;
    if (!el) { el = document.createElement('p'); el.id = 'cp-passage'; el.style.cssText = 'margin:6px 0 0;font-size:13px;line-height:1.45;color:#92400e'; host.appendChild(el); }
    if (el.textContent !== t) el.textContent = t;
  }
  /* espace entre les jambes du U : le plus étroit, au fond ou au bout des jambes (angles par coin) */
  function uGap(S) {
    var c = (typeof window.CP_cornerAngles === 'function') ? window.CP_cornerAngles(S) : null;
    if (!c || typeof window.CP_geomU !== 'function') return num(S.Lc);
    var g = window.CP_geomU({ Lc: num(S.Lc), Pc: num(S.Pc), Lg: num(S.Lg), Ld: num(S.Ld), Pl: num(S.Pl), Pr: num(S.Pr), jl: 'retour', jr: 'retour', aL: c.g, aR: c.d });
    return Math.min(g.sides.d.I1[0] - g.sides.g.I1[0], g.sides.d.I2[0] - g.sides.g.I2[0]);
  }

  function wrap(A) {
    if (A.__cpFormeWrapped || typeof A.resetDimensionsForLayout !== 'function') return;
    A.__cpFormeWrapped = true;

    /* onCommit des cotes de saisie, relevés à chaque rendu */
    var commits = {};
    var oDim = A.addDim;
    A.addDim = function () {
      var o = arguments[4] || {}, m = String(o.txt || '').trim().match(/^([LPH]\d)\s*:/i);   /* A-364 : « H1 » = P1 d'une crédence */
      if (m && o.editable !== false && typeof o.onCommit === 'function') commits[m[1].toUpperCase().replace(/^H/, 'P')] = o.onCommit;
      return oDim.apply(this, arguments);
    };

    /* ── A-307 (AUDIT Tours 567, 588, 607) : borne d'une cote = celle des pièces qu'elle allonge ──
       Une cote hors tout (L1 du G : montant gauche filant + plan du haut) n'est pas une pièce. Chaque cote de longueur du L,
       du U ou du G est essayée à blanc à sa valeur et à +1 mm (son onCommit, rendu neutralisé, état remis ensuite, comme
       gOpenWith de cp-modele) : les pièces qu'elle allonge (cp-modele, au maximum de pièce ; plans de cp-pierre-angle, à
       BR_MAX) donnent sa borne, valeur + la plus petite marge. Les angles hors équerre sont compris : l'essai suit la
       géométrie. Une cote qui n'allonge aucune pièce, et le plan droit (la cote est la pièce), gardent la borne de la règle
       (condition b). Le minimum reste celui de la règle. */
    function enSim() { return !!(window.CP_enSimulation && window.CP_enSimulation()); }
    function mesures(B) {                                                  /* longueurs bornées : { clé : { mm, max } } */
      var out = {};
      [window.CP_longueursPieces, window.CP_longueursMax].forEach(function (f) {
        if (typeof f !== 'function') return;
        try { f(B).forEach(function (m) { if (isFinite(num(m.mm)) && num(m.max) > 0) out[m.cle] = { mm: num(m.mm), max: num(m.max) }; }); } catch (e) {}
      });
      return out;
    }
    function aBlanc(B, k, v) {                                             /* mesures avec la cote k à v, état remis ensuite */
      var f = commits[k]; if (typeof f !== 'function') return null;
      var snap = {}, x, rr = B.render, res = null;
      for (x in B.S) if (Object.prototype.hasOwnProperty.call(B.S, x) && (B.S[x] === null || typeof B.S[x] !== 'object')) snap[x] = B.S[x];
      B.render = function () {};
      try { f.call(B, v); res = mesures(B); } catch (e) { res = null; }
      finally { B.render = rr; for (x in snap) B.S[x] = snap[x]; }
      return res;
    }
    /* → { cotes : { L1 : borne }, de : { clé de pièce : { k : cote qui l'allonge (la 1re du dessin), max : sa borne } } } */
    function bornesCotes(B) {
      if (!B || !B.S || !/^(angle|u-shape|g-shape)$/.test(B.S.layout) || enSim()) return null;
      var s = shown(B), out = { cotes: {}, de: {} };
      Object.keys(s).forEach(function (k) {
        if (k[0] !== 'L' || !(s[k] > 0)) return;
        var m0 = aBlanc(B, k, s[k]), m1 = m0 && aBlanc(B, k, s[k] + 1); if (!m1) return;
        var marge = null;
        Object.keys(m0).forEach(function (c) {
          var d = m1[c] ? m1[c].mm - m0[c].mm : 0; if (!(d > 0.01)) return;
          var g = (m0[c].max - m0[c].mm) / d; if (marge === null || g < marge) marge = g;
          if (!out.de[c]) out.de[c] = k;
        });
        if (marge !== null) out.cotes[k] = s[k] + Math.floor(marge + 1e-6);
      });
      Object.keys(out.de).forEach(function (c) { var k = out.de[c]; out.de[c] = { k: k, max: out.cotes[k] }; });
      return out;
    }
    var memo = { sig: null, res: null };                                   /* un calcul par état (contrôles, gardes, fenêtre) */
    function bornesMemo(B) {
      var v = B.getSelectedShopifyVariant ? B.getSelectedShopifyVariant() : null;
      var sig = JSON.stringify(B.S) + '|' + (v && v.id) + '|' + JSON.stringify(shown(B));
      if (memo.sig !== sig) memo = { sig: sig, res: bornesCotes(B) };
      return memo.res;
    }
    /* messages des pièces trop longues (cp-modele, cp-pierre-angle) : « Réduisez la cote L1 à 3 590 mm au plus » */
    window.CP_coteDe = function (B, cle) {
      B = B || A; if (!B || !B.S || enSim()) return null;
      var r = bornesMemo(B), c = r && r.de[cle];
      return c && c.max > 0 ? c : null;
    };
    /* fenêtre d'une cote de longueur : le moteur lit _eff.lengthLimits au clic (configurator-main, addDim) ; la borne de la
       cote y est posée le temps de ce clic, puis la règle revient */
    window.addEventListener('click', function (e) {
      var sp = e.target && e.target.closest && e.target.closest('#dims .dim:not(.readonly) .label span'); if (!sp || enSim()) return;
      var m = sp.textContent.trim().match(/^(L\d)\s*:/i), ef = A._eff; if (!m || !ef) return;
      var r = bornesMemo(A), b = r && r.cotes[m[1].toUpperCase()]; if (!(b > 0)) return;
      var ll = ef.lengthLimits;
      ef.lengthLimits = { min: ll && ll.min, max: Math.max(b, num(ll && ll.min) || 0) };
      setTimeout(function () { ef.lengthLimits = ll; }, 0);
    }, true);
    /* cotes par défaut d'une nouvelle forme (et report ci-dessous) : une pièce plus longue que son maximum est ramenée à ce
       maximum par la cote qui la porte, sans message (point 2 du Tour 588 : laqué G, L1 3 590) */
    var borner = false;
    function borneDefauts(B) {
      for (var n = 0; n < 4; n++) {
        var m = mesures(B), t = Object.keys(m).filter(function (c) { return m[c].mm > m[c].max + 0.5; })
          .sort(function (a, b) { return (m[b].mm - m[b].max) - (m[a].mm - m[a].max); });
        if (!t.length) return;
        var r = bornesCotes(B), c = r && r.de[t[0]];
        if (!c || !(c.max > 0) || typeof commits[c.k] !== 'function') return;
        commits[c.k](c.max);                                               /* l'onCommit du moteur refait le rendu */
      }
    }

    var pending = null;
    var oReset = A.resetDimensionsForLayout;
    A.resetDimensionsForLayout = function () {
      var s = shown(this);                                                 /* cotes de l'ancienne forme, encore à l'écran */
      if (s.L1 > 0 || s.P1 > 0) pending = { L1: s.L1, P1: s.P1 };
      borner = true;
      return oReset.apply(this, arguments);
    };

    /*  changer seulement le sens (L à droite <-> à gauche, G idem) garde l'angle entre les
       murs : c'est le même mur. Le moteur le remet à 90° à chaque clic de forme
       (resetEdgesAndBandingOnly, l. 1880). Changer de forme le remet toujours à 90° : en U et en G
       l'angle compte pour 2 coins, on ne reporte pas un supplément sans que le client le voie.*/
    var lastLayout = null;
    var oEdges = A.resetEdgesAndBandingOnly;
    if (typeof oEdges === 'function') A.resetEdgesAndBandingOnly = function () {
      var same = this.S.layout === lastLayout, keep = same ? this.S.innerAngle : null;
      /*  en L, changer de sens décochait sans message les chants libres choisis (-98 €) ;
         les clés des chants sont les mêmes dans les deux sens : les cases cochées sont reportées*/
      var eb = same && this.S.edgeBanding ? Object.assign({}, this.S.edgeBanding) : null;
      var r = oEdges.apply(this, arguments);
      if (keep != null) this.S.innerAngle = keep;
      if (eb) { var S = this.S; S.edgeBanding = S.edgeBanding || {}; Object.keys(eb).forEach(function (k) { if (eb[k] === true) S.edgeBanding[k] = true; }); }
      if (!same) this.S.cpClientBanding = {};                              /*  nouvelle forme, nouveaux chants*/
      return r;
    };

    /*  retirer un usinage décochait aussi un chant que le client avait coché AVANT de le
       poser (le moteur, clearAutoBandingFromEdge, décoche tous les chants que ce coin avait imposés). U,
       « côté gauche » coché : 799,60 € → chanfrein en haut à gauche 888,60 € → retrait 750,60 €. Les
       choix du client sont relevés au clic sur une case libre ; au retrait, ceux qu'il avait cochés le
       restent.*/
    var oClear = A.clearAutoBandingFromEdge;
    if (typeof oClear === 'function') A.clearAutoBandingFromEdge = function (edgeKey) {
      var S = this.S, links = Object.keys(((S.edgeBandingByEdge || {})[String(edgeKey || '')]) || {}), mine = S.cpClientBanding || {};
      var r = oClear.apply(this, arguments);
      links.forEach(function (k) { if (mine[k] === true) S.edgeBanding[k] = true; });
      return r;
    };
    /*  le plan droit, le L et le G ont en plus leur mémoire des chants imposés
       au rendu précédent (_forcedBandingPrev, _forcedAnglePrev, _forcedGPrev ; et, par profondeur,
       _depthForced…) : un chant imposé qui ne l'est plus est décoché. Avant chaque rendu, un chant que
       le client a coché lui-même en est retiré : le moteur ne le décoche plus.*/
    function keepClientBanding(B) {
      var mine = B.S && B.S.cpClientBanding; if (!mine) return;
      Object.keys(B).forEach(function (p) {
        var m = B[p];
        if (!/^_(forced\w*Prev|depthForced\w*)$/.test(p) || !m || typeof m !== 'object') return;
        Object.keys(mine).forEach(function (k) { if (mine[k] === true && m[k]) m[k] = false; });
      });
    }

    var oRender = A.render, depth = 0, lastSig = null;
    A.render = function () {
      /*  changer de forme ou de sens ferme les fenêtres ouvertes (coin, cote, menu des
         usinages, jambages, évier) : elles portaient sur un coin ou une cote qui n'existe plus*/
      var S = this.S, sig = S.layout + '|' + (S.layout === 'angle' ? S.angleDir : S.layout === 'g-shape' ? S.gDir : '');
      if (depth === 0 && lastSig !== null && sig !== lastSig) {
        try {
          if (typeof this.closeMenu === 'function') this.closeMenu();
          if (typeof this.closeEdgePopup === 'function') this.closeEdgePopup();
          ['legs-popup', 'sink-popup'].forEach(function (id) { var p = document.getElementById(id); if (p) p.classList.add('hidden'); });
        } catch (e) { console.warn('[cp-forme]', e); }
      }
      if (depth === 0) lastSig = sig;
      depth++;
      try { return renderOnce.apply(this, arguments); }
      finally { depth--; if (depth === 0) warnG(this); }                     /* message sur l'état final, pas sur un rendu intermédiaire */
    };
    function renderOnce() {
      if (pending) commits = {};
      keepClientBanding(this);
      var r = oRender.apply(this, arguments);
      lastLayout = this.S.layout;
      if (pending) {
        /* chaque onCommit du moteur relance lui-même App.render par TOUTE la chaîne des
           ajouts (relevé des pièces de cp-texture, tracé, accessibilité) : pas de rendu en plus
           ici, qui sauterait les ajouts extérieurs et laisserait App._cpPieces en double*/
        var p = pending, notes = [], now = shown(this); pending = null;
        var gBefore = this.S.layout === 'g-shape' ? gOpening(this.S) : null;   /* passage du G avant le report */
        ['L1', 'P1'].forEach(function (k) {
          var want = p[k];
          if (!(want > 0) || typeof commits[k] !== 'function') return;
          if (k === 'L1' && this.S.layout === 'g-shape') {                 /*  jamais un G impossible*/
            /*  la longueur reprise ne doit pas obliger à raccourcir le retour par défaut. Depuis
               le plan droit (2 400 mm), le G s'ouvrait sur « Retour ramené à 400 mm pour garder un passage de
               800 mm », posé sur le dessin, à propos d'un retour que le client n'a pas choisi. Plus courte que
               montants + retour + 800 mm de passage, la longueur n'est pas reprise : le G garde ses cotes par
               défaut, sans message. Reprise, elle garde le retour et au moins 800 mm de passage (plus le passage
               d'avant, qui n'était qu'un défaut).*/
            var needW = num(this.S.Pgleft) + num(this.S.Pgright) + num(this.S.Greturn) + PASSAGE_MIN;
            if (want < needW) return;
          }
          if (k === 'L1' && this.S.layout === 'u-shape') {                 /* U court : même règle, 800 mm entre les jambes*/
            var minU = num(this.S.Pl) + num(this.S.Pr) + PASSAGE_MIN;
            if (want < minU) { notes.push('L1 de ' + want + ' mm trop courte pour un U (' + minU + ' mm au moins, pour 800 mm entre les jambes) : longueur du U par défaut gardée'); return; }
          }
          var v = bound(this, k, want);
          if (v !== want) notes.push(k + ' ramenée à ' + mmTxt(v) + ' mm pour cette forme');
          if (now[k] !== v) commits[k](v);
        }, this);
        if (gBefore !== null) keepGOpen(this, Math.min(gBefore, PASSAGE_MIN), notes);   /*  filet, 800 mm*/
        if (notes.length) { var t = notes.join(' ; ') + '.'; toast(t.charAt(0).toUpperCase() + t.slice(1)); }
      }
      if (borner && !enSim()) { borner = false; borneDefauts(this); }     /* A-307 : après le report */
      return r;
    }
  }

  var tries = 0;
  var timer = setInterval(function () {
    var A = getApp();
    if (A && A.S && typeof A.render === 'function' && typeof A.addDim === 'function' && typeof A.resetDimensionsForLayout === 'function') { clearInterval(timer); wrap(A); }
    else if (++tries > 400) clearInterval(timer);
  }, 50);
})();
